/**
 * Logo Premium Energy : bulle « P » (queue en bas à gauche) contenant un E,
 * en dégradé turquoise → vert, reproduit en SVG d'après la charte.
 */
export function BrandMark({ size = 36 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 116 120"
      role="img"
      aria-label="Premium Energy"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <defs>
        <linearGradient id="pe-brand-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#2bd5dc" />
          <stop offset="100%" stopColor="#2fe79e" />
        </linearGradient>
      </defs>
      <path
        d="M32 4h52c15.5 0 28 12.5 28 28v52c0 15.5-12.5 28-28 28H46L14 117c-4.5 3.6-11-.6-11-6V32C3 16.5 16.5 4 32 4z"
        fill="url(#pe-brand-gradient)"
      />
      <text
        x="60"
        y="62"
        textAnchor="middle"
        dominantBaseline="central"
        fontFamily="'Public Sans', 'Inter', sans-serif"
        fontWeight={800}
        fontSize="54"
        fill="#ffffff"
      >
        E
      </text>
    </svg>
  );
}

/** Texte de marque en dégradé, à placer à côté du BrandMark. */
export const brandTextGradient = {
  background: 'linear-gradient(90deg, #29cfd8 0%, #2fe79e 100%)',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  color: 'transparent',
} as const;
